import { ProjectWrapper } from '@/features/projects/components/ProjectWrapper';

export default function ProjectPage() {
  return (
    <div className="flex">
      <ProjectWrapper />
    </div>
  );
}
